import { Auth0Provider } from "@auth0/auth0-react";

const AuthProviderWrapper = ({ children }) => (
  <Auth0Provider
    domain="dev-gxtuta2f33lqncy7.us.auth0.com"
    clientId="q8CT0BQOcQndWbiRJjJ6wrtLm8ewgaNf"
    authorizationParams={{
      redirect_uri: window.location.origin
    }}
  >
    {children}
  </Auth0Provider>
);

export default AuthProviderWrapper;
